import axios from 'axios';
import qs from 'qs';
import { getFeedPickerConfig } from '../utils/feedPickerConfig';

function normalizeOptionsResponse(data) {
    // ожидаем объект вида { taste:[], brand:[], special_need:[] }
    if (!data || typeof data !== 'object') return {};

    const pickArray = (key) => {
        const v = data[key];
        return Array.isArray(v)
            ? v.map(String).map(s => s.trim()).filter(Boolean)
            : [];
    };

    return {
        taste: pickArray('taste'),
        brand: pickArray('brand'),
        special_need: pickArray('special_need'),
    };
}

export async function fetchOptionsByFields({ fields = [], params = {} }) {
    const { optionsUrl } = getFeedPickerConfig();
    if (!optionsUrl) throw new Error('OPTIONS_URL_NOT_SET');

    const res = await axios.get(optionsUrl, {
        params: { ...params, fields },
        responseType: 'json',
        paramsSerializer: (p) =>
            qs.stringify(p, { arrayFormat: 'brackets', encode: true }),
    });

    return normalizeOptionsResponse(res.data);
}
